import * as i0 from '@angular/core';
import { inject, ElementRef, Renderer2, input, effect, Directive } from '@angular/core';
let NgxTrackableIdDirective = /*#__PURE__*/(() => {
  class NgxTrackableIdDirective {
    constructor() {
      // Injections
      this.el = inject(ElementRef);
      this.renderer = inject(Renderer2);
      // Inputs
      this.trackerId = input.required();
      this.isSharedComponent = input(false);
      effect(() => {
        if (this.trackerId()) {
          if (this.isNameUniqueInParent()) {
            const uniqueId = this.generateUniqueId();
            this.renderer.setAttribute(this.el.nativeElement, 'data-tracker', uniqueId);
          } else {
            this.warnDeveloper();
          }
        }
      });
    }
    generateUniqueId() {
      const parentTagName = this.tagNameShortener(this.getParentComponentTagName());
      const tagName = this.tagNameShortener(this.el.nativeElement.tagName.toLowerCase());
      return `${parentTagName}-${tagName}-${this.trackerId().toLowerCase()}`;
    }
    getParentComponentTagName() {
      let parentElement = this.el.nativeElement.parentElement;
      let foundFirstComponent = false;
      while (parentElement) {
        const tagName = parentElement.tagName.toLowerCase();
        if (!['div', 'span', 'p', 'section', 'header', 'footer', 'main', 'article', 'aside', 'nav'].includes(tagName)) {
          // If isSharedComponent is true, skip the first component found
          if (this.isSharedComponent() && !foundFirstComponent) {
            foundFirstComponent = true;
          } else {
            return tagName;
          }
        }
        parentElement = parentElement.parentElement;
      }
      return 'unknown-component';
    }
    tagNameShortener(tagName) {
      const tagNameSections = tagName.split('-');
      if (tagNameSections.length < 3) {
        return tagName;
      }
      const shortened = tagNameSections.slice(0, -2).map(section => section.charAt(0)).join('');
      return `${shortened}-${tagNameSections.slice(-2).join('-')}`;
    }
    // Checks if the name is unique within the parent's children.
    isNameUniqueInParent() {
      const parent = this.el.nativeElement.parentNode;
      const siblings = Array.from(parent.children);
      const nameMatches = siblings.filter(element => element !== this.el.nativeElement && element.getAttribute('trackerId') === this.trackerId());
      return nameMatches.length === 0;
    }
    warnDeveloper() {
      console.error(`trackerId Error: The name "${this.trackerId()}" is not unique within its parent element's children.`);
    }
    static {
      this.ɵfac = function NgxTrackableIdDirective_Factory(t) {
        return new (t || NgxTrackableIdDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgxTrackableIdDirective,
        selectors: [["", "ngxTrackableId", ""]],
        inputs: {
          trackerId: [i0.ɵɵInputFlags.SignalBased, "trackerId"],
          isSharedComponent: [i0.ɵɵInputFlags.SignalBased, "isSharedComponent"]
        },
        standalone: true
      });
    }
  }
  return NgxTrackableIdDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-trackable-id
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxTrackableIdDirective };
